// ConstantContext.js
import React, { createContext, useContext } from 'react';

const GamesContext = createContext();

export const GamesProvider = ({ children }) => {

    const puttingGames = [
        {
            group: "Fundamentals",
            drills: [
                ,
                {
                    name: "12 to 6 feet ball start",
                    description: "Put 2 tees/lines one at 12' and one at 6'. Using Peltz Tutor hit the first ball as close as possible to 12ft, hit the next one shorter (leapfrog). Game ends when you strike a marble on peltz tutor, hit another golf ball or roll it past the previous one. Record number of balls that finished between 12 and 6 feet.",
                    low: 0,
                    high: 8,
                    isLow: false,
                    group: "Fundamentals"
                },
                {
                    name: "King of ball start",
                    description: "You will hit a total of 36 putts to a phantom hole with a Peltz Tutor. 12 putts from 6ft, 12 from 9ft and 12 from 12ft. Half of them from each distance will be with eyes closed. To get a point you have to hit it in between the marbles and the ball has to stop past the hole but no more than 3ft. Time 20-25 min",
                    low: 32,
                    high: 34,
                    isLow: false,
                    time: "20-25 min",
                    group: "Fundamentals"
                },
                {
                    name: "Technique circle",
                    description: "You will setup 8 putts from 6ft around a hole on a small break. You will complete 4 rounds for a total of 32 putts. For each round you will hit 5 putts, 2 putts with Peltz Tutor (L-R & R-L), 1 putter aim check (check if putter is ligned up correctly, e.g. middle of the hole for a straight putt).",
                    low: 27,
                    high: 30,
                    isLow: false,
                    group: "Fundamentals"
                }, {
                    name: "Aiming Challenge",
                    description: "You will need a phantom hole, peltz putting tutor or triangle alingment tool, a string, golf ball and a partner. On the phantom hole draw another circle or mark points that create a hole that is 2\" in diameter. Set a tee 10' from the phantom hole. Now set up to the putt assuming it's perfectly straight. After you set up to the ball your partner will take away the golf ball and put the putting tutor along the putter face. Once that is done you will take the string and draw a line with it starting where the ball would be and going towards where the tutor is aiming towards the hole. If the string is inside the small hole you get 2 points, if it's inside the regular hole it's 1 point. Otherwise is's 0 points. Repeat this 10 times.",
                    low: 12,
                    high: 16,
                    isLow: false,//is low good,
                    group: "Fundamentals"
                },
                {
                    name: "Aiming Challenge (slopes)",
                    description: "You will need a phantom hole, peltz putting tutor or triangle alingment tool, a string, golf ball and a partner. On the phantom hole draw another circle or mark points that create a hole that is 2\" in diameter. Place the hole on a break. Set one tee 10' from the phantom hole on a straight putt, one on L-R putt and one on R-L putt. You will always set up to the middle of the hole. After you set up to the ball your partner will take away the golf ball and put the putting tutor along the putter face. Once that is done you will take the string and draw a line with it starting where the ball would be and going towards where the tutor is aiming towards the hole. If the string is inside the small hole you get 2 points, if it's inside the regular hole it's 1 point. Otherwise is's 0 points. Repeat this 3 times for the total of 9 'putts'.",
                    low: 10,
                    high: 14,
                    isLow: false,//is low good
                    group: "Fundamentals"
                },
            ]
        },
        {
            group: "Green Reading",
            drills: [
                {
                    name: "Aimpoint Spot Check",
                    description: "Walk around the greed and feel side tilt in 10 different areas of the green. Call out the slope and place a level across your toes. To receive credit your guess must be +/- 0.5 of the actual break. Write down how many correct reads you had.",
                    low: 8,
                    high: 9,
                    isLow: false,//is low good,
                }, {
                    name: "2-5m Green Reading Drill",
                    description: "Use a Pelz Tutor. 4 random putts, distance 2, 3, 4 & 5m. One putt at a time has to be hit until you hole it without touching the marbles (good read and ball start). Score = total number of putts to hole all four situations. Tour average is 11.6 putts. Time to complete the drill 10-20 min.",
                    low: 9,
                    high: 14,
                    isLow: true,
                    time: "10-20 min",
                    group: "Green Reading"
                },
                {
                    name: "AimPoint Calibration",
                    description: "Find in order a 0%, 1%, 1.5%, 2%, 2.5%, 3%, 3.5%, 4%, 5% slopes. Write how many tries it took you to find all of them. A sucessful find has to be within +/- 0.5%.",
                    low: 14,
                    high: 16,
                    isLow: true,//is low good
                    group: "Green Reading"
                }, {
                    name: "6-10 feet green reading",
                    description: "9 random putts (with Pelz Tutor, Short Game Gains or similar). 3 x 6 feet, 3 x * feet, 3 x 10 feet. Read ir align the start plate and you have one attempt to hole the putt. 1 point per putt, max score = 9.",
                    low: 4,
                    high: 6,
                    isLow: false,//is low good
                    group: "Green Reading"
                },
            ]
        },
        {
            group: "Short Putts",
            drills: [
                {
                    name: "4 feet drill",
                    description: "5 tees around the hole from 4 feet (centre hole to centre ball). 5 rounds, a total of 25 putts. Score it total putts made. A typical tour score is 20-24.",
                    low: 20,
                    high: 24,
                    isLow: false
                },
                {
                    name: "Break Putt Drill",
                    description: "3 putts RL & 3 puts LR from 4' on the same hole. Change hole and do the same from 6, 8, 10'. See how many you can hole out of 24 putts. Tour average is 16.5.",
                    low: 16,
                    high: 17,
                    isLow: false,
                    group: "Short Putts"
                },
                {
                    name: "4-5-6 feet 3-4-5 meter-drill",
                    description: "Hole 6 putts with as few trials as possible. 4-5-6 feet and 3-4-5 meter (10-13-16 feet). Start on shortest putt, and finish with holing 5 meters. If you miss one of the 'feet-putts' you move one putt back, if you miss one of the 'meter-putts' hit the same putt again. Score is number of putts needed to complete the drill. Tour verage is 13.38.",
                    low: 14,
                    high: 10,
                    isLow: true,
                    group: "Short Putts"
                }, {
                    name: "4-7 feet drill",
                    description: "All random putts. 4 Challenges: 1. 3x4' in a row, 2. 3x5' in a row, 3. 2x 6' in a row, 4. 2x7' in a row. Score is total number of putts needed to complete the drill. Tour players need 16-20 putts",
                    low: 20,
                    high: 16,
                    isLow: true,
                    time: "15-20 min",
                    group: "Short Putts"
                }, {
                    name: "Hell drill",
                    description: "You will setup 5 coins at 6 feet and 5 tees at 8 feet. You will always putt from where the coin is. When you make the putt you move the coin 1ft back. If you miss a putt you move the coin 1ft forward. The game ends when all the coins are at 8ft or more. As the score put down the time it took you to finish the drill.",
                    low: 25,
                    high: 60,
                    isLow: true,
                    group: "Short Putts"
                },
                {
                    name: "Extreme Hell drill",
                    description: "You will setup 5 coins at 7 feet and 5 tees at 10 feet. You will always putt from where the coin is. When you make the putt you move the coin 1ft back. If you miss a putt you move the coin 1ft forward. The game ends when all the coins are at 10ft or more. As the score put down the time it took you to finish the drill.",
                    low: 40,
                    high: 70,
                    isLow: false,
                    group: "Short Putts"
                },
                {
                    name: "Kids Hell drill",
                    description: "You will setup 5 coins at 3 feet and 5 tees at 5 feet. You will always putt from where the coin is. When you make the putt you move the coin 1ft back. If you miss a putt you move the coin 1ft forward. The game ends when all the coins are at 5ft or more. As the score put down the time it took you to finish the drill.",
                    low: 30,
                    high: 50,
                    isLow: false,
                    group: "Short Putts"
                },
                {
                    name: "Darts",
                    description: "You will putt from 4 directions: soft L-R downhill, soft R-L downhill, soft L-R uphill, soft R-L uphill. Set up tees at 4, 5, 6, 7, 8 and 9ft from each direction. You will start from all 4' putts, then all 5' and so on. Write down how many putts you made. Good score is 18.",
                    low: 17,
                    high: 18,
                    isLow: false,
                    group: "Short Putts"
                },
                {
                    name: "Zach Johnson",
                    description: "You will set up putts from 3, 6 and 9ft to 6 different holes. Play from each location until holed out. Good score is 23 or better",
                    low: 22,
                    high: 23,
                    isLow: true,
                    group: "Short Putts"
                },
                {
                    name: "McCabe Drill",
                    description: "Set up 8 putts from 5'. Once you make 3 straight putts from one place you move to the next one. If you miss a putt you move back a station. Write down the time it took you to finish the drill.",
                    low: 0,
                    high: 100,
                    isLow: false,
                    group: "Short Putts"
                },
                {
                    name: "High/Low drill",
                    description: "Place the ball ona mark about 3m from the holw on a solid side-sclope (2-4%). Then place a tee about halfway. The objective is to hole two putts, one above and one below the dee from the same spot in as few putts as possible. Do the same for R-L and L-R break. This drill promotes the skill of combining speed and break. Time 5-20min.",
                    low: 11,
                    high: 15,
                    isLow: true,//is low good
                    time: "5-20 min",
                    group: "Short Putts"
                },
                {
                    name: "6x6 feet in-a-row",
                    description: "Place 6 tees around the hole 6ft from the hole. The goal is to make 6 putts in a row. Writr down the time it took to finish the drill",
                    low: 10,
                    high: 20,
                    isLow: true,//is low good
                    group: "Short Putts"
                },
                {
                    name: "4-5ft in-a-row",
                    description: "Place 4 tees at N/E/S/W 4 feet from the hole and 4 tees at NE/SE/SW/NW 5 feet from the hole. The goal is to make all 8 putts in a row. Write down time it took you to finish the drill.",
                    low: 15,
                    high: 20,
                    isLow: true,//is low good
                    group: "Short Putts"
                },

                {
                    name: "2m 3-in-a-row",
                    description: "Place 4 tees 2m/6.5ft from the hole. Complete from one tee to move to the next one. Write down how many putts it took you to hole 3 in a row from each of the four tees. Tour avg is 20.95",
                    low: 18,
                    high: 21,
                    isLow: true,//is low good
                    group: "Short Putts"
                },
                {
                    name: "3-5-7",
                    description: "You will need 10 tees around the hole. Place 5 tees 3ft from the hole, 3 tees 5ft from the hole, 2 tees 7ft from the hole. You will place the 7 footers more in the middle to end part of the game. To win the game you need to make 9/10 putts. Write down the score each time you attempt the drill.",
                    low: 8,
                    high: 10,
                    isLow: false,//is low good
                    group: "Short Putts"
                },
                {
                    name: "North, South, East, West",
                    description: "Place four balls on the green, each three feet from the same cup, as in the points on a compass. Using your full process, attempt to hole each putt, keeping track of your makes and misses. Repeat the process at four feet and then at five feet, striking a total of 12 putts. Consider the game won if you can hole 10 out of the 12 putts. Write down the score each time you attempt the drill.",
                    low: 9,
                    high: 11,
                    isLow: false,//is low good
                    group: "Short Putts"
                },
                {
                    name: "Tornado",
                    description: "Mark six putt locations with coins or tees, starting at two feet away from the hole and at one-foot progressions. Angle the marks so they create a widening curve, creating a unique read for each putt and an unobstructed path to the hole. Start by making the two-footer, then cycle through the other five putts. The goal? Don’t miss. If you do, start anew. If you can make six in a row within five restarts, consider the game won. Write down the number of restarts.",
                    low: 4,
                    high: 6,
                    isLow: true,//is low good
                    group: "Short Putts"
                }
            ]
        },
        {
            group: "Medium Putts",
            drills: [
                {
                    name: "2-6 meter drill (holed putts)",
                    description: "Drill for mid-range putts and analysis of miss patterns. Four lines: straight upp, straight down, left-to-right, right-to-left. 15 putts on each line (6-5-4-3-2m/20-16-13-10-7ft), a total of 60 putts. Tour average is 26.1 holed putts. Also note the number of putts that that reached the front edge of the hole, and not went more than 3 feet behind the hole and record in speed version of the drill.",
                    low: 25,
                    high: 27,
                    isLow: false,
                    group: "Medium Putts"
                },
                {
                    name: "2-6 meter drill (speed)",
                    description: "Write down the number of putts from 2-6 meter drill that reached the front edge of the hole, and not went more than 3 feet behind the hole. Tour average is 54.2",
                    low: 54,
                    high: 55,
                    isLow: false,
                    group: "Medium Putts"
                },
                {
                    name: "4-5-6 feet 3-4-5 meter-drill",
                    description: "Hole 6 putts with as few trials as possible. 4-5-6 feet and 3-4-5 meter (10-13-16 feet). Start on shortest putt, and finish with holing 5 meters. If you miss one of the 'feet-putts' you move one putt back, if you miss one of the 'meter-putts' hit the same putt again. Score is number of putts needed to complete the drill. Tour verage is 13.38.",
                    low: 10,
                    high: 14,
                    isLow: true,
                    group: "Short Putts"
                },
                {
                    name: "4-5-6m offence",
                    description: "Alternate random putts from 4-5-6-4-5-6...m (13-16.5-20ft). Drill ends when you get 15 points. Hole = 3p, missed inside 3ft pass hole = 1p, more than 3ft pass = 0p, short or 3-putt=-3p. Record total number of putts needed to complete the drill. Tour avg. 12.28. Time 10-20 min.",
                    low: 11,
                    high: 13,
                    isLow: true,
                    time: "10-20 min",
                    group: "Medium Putts"
                },
                {
                    name: "1-2-3-4-5-6... meter drill",
                    description: "All putts on the same line. Start from 1 meter and more one meter back every time you hole a putt. You have maximum 1 chance from 1 meter, 2 chances from 2 meters and so on. From 6 meters and over you always have max 6 chances. Write down the last distance you were able to hole the putt from.",
                    low: 0,
                    high: 100,
                    isLow: true,//is low good
                    group: "Medium Putts"
                },
            ]
        },
        {
            group: "Lag Putts",
            drills: [
                {
                    name: "Two putt ladder",
                    description: "Start from 10m/32ft. Random putts all the time. Add 1m/3ft if you 2-putt, and add 2m/6ft if you hole the long putt. Game over when you 3-putt. Record the last putt you hit before 3-putting. Tour avg. 18.84m",
                    low: 17,
                    high: 20,
                    isLow: false,
                    time: "3-20 min"
                },
                {
                    name: "6-8-10 meter up/down-drill",
                    description: "Two lines, one up one down. Tees on 6, 8, 10m (20, 26, 32ft) on both lines. Hit series of 3 putts: 6 up, 6 down, 8 up, 8 down, 10 up, 10 down, total = 18putts. Holed = birdie, good speed = par, short or more than 3ft pass hole = bogey. Record your score in relation to par Tour avg. is +0.64. ",
                    low: 0,
                    high: 1,
                    isLow: true
                }, {
                    name: "Leapfrog",
                    description: "Place 2 tees 10’ apart. Then walk from the nearest tee 20’ away. Putt first ball just past first tee. Then putt next ball past the previous ball putted. Then putt the next ball just past the second ball. Continue this until you get 8 balls in between the tees. You start over if you hit a ball or don’t get a ball past the previous ball that you hit. Goal is to get all 8 balls in between the tees. Write down how many times it took you.",
                    low: 0,
                    high: 100,
                    isLow: true,
                    group: "Lag Putting"
                },
                {
                    name: "Lag putt footage",
                    description: "Place tees at 30', 40', 50', 60' and 70'. Add up the total distanca of each putt from the hole. The goal is to get 18' or less.",
                    low: 15,
                    high: 18,
                    isLow: true,
                    group: "Lag Putting"
                },
                {
                    name: "10 Hole Putting Benchmark Game",
                    description: "You will play 10 holes on the putting green. Pick a new starting location and different hole each time. After you hit your first putt, continue putting until you hole out. These are the starting distances for each putt: 20', 35', 25', 40', 30', 20', 35', 25', 40', 30'. Tour average is 19.86 putts",
                    low: 19,
                    high: 20,
                    isLow: true,
                    group: "Lag Putting"
                },

                {
                    name: "Need for Speed",
                    description: "It's a challengin drill on quick greens (12 stimp or more). You have to complete 6 putts in a row AND 1 of 6 putts needs to be holed: 1. 20ft/6m within 3ft behind the hole. 2. 30ft/9m withinn 3ft circle around the hole. 3. 15ft/4.5m within 3ft circle behind the hole. 4. 40ft/12m within 3ft circle around the hole. 5. 10ft/3m within 3ft circle behind the hole. 6. 50ft/15m within 3ft circle around the hole.",
                    low: 0,
                    high: 100,
                    isLow: true,//is low good
                    group: "Lag Putting"
                }, {
                    name: "Worst Ball Lag Putting",
                    description: "Pick 5 tough lag putts, hit two balls, need to hole our the worst ball. Write down how many did you complete",
                    low: 3,
                    high: 5,
                    isLow: false,//is low good
                    group: "Lag Putting"
                },
            ]
        },

        {
            group: "Challenges",
            drills: [
                {
                    name: "Lagergren Drill",
                    description: "You have to complete in order: two-putt a tough lag putt, hole 8-footer, hole 4-footer with the Pelz tutor, Make a tough up&down. Write down the time it took you to complete the drill",
                    low: 0,
                    high: 100,
                    isLow: true,//is low good
                    group: "Challenge"
                },
                {
                    name: "2-hour challenge",
                    description: "You have to complete: 1) 7 x random 6ft putts in a row. 2) Hole 9 different chip shots. 3) Play 7 very tough holes without a 3 putt. 4) Hole 2-in-a-row from 3, 4, 5 & 6m (10, 13, 16 & 19ft). Write down 1 if you completed the challenge and 0 if not.",
                    low: 0,
                    high: 1,
                    isLow: false,//is low good
                    group: "Challenge"
                },
            ]
        },


        /* 
        {
            name: "Star ladder",
            description: "Set up tees at 3' at South, 4' at East, 5' at North, 6' at West, 7' at SE, 8' at NE, 9' at NW, 10' at SW. Start at 3ft and move counter clockwise to end on a 10ft putt. Hole = move to next putt, miss = move back (no futher than 3'). Record total number of putts.",
            low: 0,
            high: 100,
            isLow: true
        }, */
        /*   {
              name: "Circuit",
              description: "3 lines on the same hole, lines 1 and 2 have safezones: 1: 12-30ft every 3ft (7 putts) safezone 2ft semi circle past the hole , 2: 35-50fr every 5ft (4 putts) safezone 2ft circle around the hole, 3: 3-9ft every 1ft (7 putts). Lines 1 and 2: hole=move on + life*, safe sone = move on, outside safe zone = move back. Line 3 hole = move on, miss = move back. *life = avoid moving back or -1 off final score. Record numer of putts needed to finish the game. ",
              low: 0,
              high: 100,
              isLow: true
          }, */
        /* {
            name: "Safety Drawback",
            description: "18 holes of random putts. 6x10-15ft, 6x12-25ft, 3x25-40ft, 3x 40ft+. Safe zones: Inside 25ft 2ft semicircle past the front edge of the hole. 25-40' 2ft circle, 40'+ 3ft circle. If the putt is in the safezone hole out as normal, if outside pull back 1 putter length and continue until the ball is in the hole. Each hole is par 2. Record score to par.",
            low: 0,
            high: 100,
            isLow: true
        }, */

    ]
    const argGames = [
        {
            name: "21",
            description: "Play 9 holes (3 easy, 3 medium, 3 hard. Grass only) no longer than 30m or yards. Always drop the ball. Putt out every hole. Write down your score. To win the game score 21 or better.",
            low: 20,//less than or equal
            high: 22,//more than or equal
            isLow: true
        },
        {
            name: "Knockout",
            description: "Choose a pin around 10y/9m from the edge of the green. Create 6 zones (5ft long) in one line. Choose a place to hit from (1-20y off the edge off the green) and grab some balls. The Goal is to eliminaate all zones (front to back or back to front). Zone is eliminated when the ball lands in the zone and finishes 6ft or less from the hole. Score is the number of shots needed to eliinate all zones. To win the game you need to finish in 18 shots or less.",
            low: 17,
            high: 19,
            isLow: true
        },
        {
            name: "Darts",
            description: "Play 9 holes (3 easy, 3 medium, 3 hard. Grass only) inside 30m. Always drop the ball. No need to putt out. Hole = 5p. Inside 1 club=3p, 2 clubs=2p. On hard shots there's extra zone 3 clubs=1p. Outside 3 clubs=0p. Write down your score. To win the game you need 18 points or less.",
            low: 17,
            high: 20,
            isLow: false
        },
        {
            name: "Bunker Darts",
            description: "Play 9 holes (3 easy, 3 medium, 3 hard. Bunker only) inside 30m. Always roll the ball. No need to putt out. Hole = 5p. Inside 1 club=3p, 2 clubs=2p, 3 clubs=1p. Outside 3 clubs=0p. Write down your score.  To win the game you need 14 points or less.",
            low: 13,
            high: 16,
            isLow: false
        },

        {
            name: "5 coins",
            description: "Play 5 easy-medium holes. Place a tee or a coin where you want the ball to land. For a chip to be successful the ball needs to land within 2ft of the coin and within 3ft from the hole. To win the game you need to finish the drill in shots or less. If you chip in you deduct 1 from the attempts.",
            low: 8,
            high: 10,
            isLow: true
        },
        {
            name: "Chipping leapfrog",
            description: "Pick a place on the green where you have around 20m of room and mark the edge of the green and a spot 20m from it. Drop some balls 10m from the edge of the green. Hit first ball as close as possible to the edge of the green. Hit the second one between the first ball and the marker and so on. Score is the number of balls in the 20m zone. Drill ends when you hit a ball too short or run out of room.",
            low: 0,
            high: 100
        },
        {
            name: "Elimination",
            description: "Pick a hole on the green. In the bunker find 6 spots: Uphill, Downhill, Ball above-, Ball below-the feet, plugged, normal. To eliminate the spot, ball has to finish 6ft or less from the hole. You hit until the spot is eliminated and then you move on. Score is the number of shots needed to eliminate all the spots.",
            low: 0,
            high: 100,
            isLow: true
        },
        {
            name: "Chipping ladder",
            description: "Hit chips through the agility ladder. How many shots does it take you to get through the ladder in a row?",
            low: 0,
            high: 100,
            isLow: true
        },
        {
            name: "Chipping in-a-row ladder",
            description: "Find a basic chip, pretty flat and place some balls close to the edge of the green. Always hit three balls. With a string/tees mark 10 zones that are 2 feet long and not far from the edge (mayb 3-5m). Start aiming at the closest zone. 3/3 in the zone = move two zones up, 2/3 = move one zone up, 1/3 = same zone, 0/3 = move one zone closer. Write down time it took to finish the drill (at least 1/3 in the 10th zone or 3/3 in 9th zone)",
            low: 0,
            high: 100,
            isLow: true
        },
        {
            name: "9 star",
            description: "9 basic chips requiring 3 trajectories. 3xhigh,stock,lower. Best score is 9. Place Tee for Landing Area and finish no more than 4ft from the hole. This can be done for roughs (8ft) etc. Adjust finish area accordingly Keep going until completed.",
            low: 0,
            high: 100,
            isLow: true
        },
        {
            name: "10 Ball Make",
            description: "Select 10 random 10-yard short-game shots. Make them pretty simple—so easy you should think about holing each one out. Play all 10 shots with the goal of making a minimum of two. One make or less is a loss, and two or more is a win. This game fosters the correct focus for using your wedge game to make birdies.",
            low: 1,
            high: 2,
            isLow: true
        },

    ]

    const appGames = [
        {
            name: "7 Circle Wedge Drill",
            description: "Take your favorite wedge. How many shots does it take you to hit it through every circle?",
            low: 0,
            high: 100,
            isLow: true
        },
        {
            name: "7 Circle Wedge Drill (hard)",
            description: "Take your favorite wedge. If you miss, start over. How many shots does it take you to hit it through every circle in a row?",
            low: 0,
            high: 100,
            isLow: true
        },
        {
            name: "7 Circle Trajectory",
            description: "Take your 8 iron. How many shots does it take you to hit a ball through each circle? Then take your 5 iron and do the same thing.",
            low: 0,
            high: 100,
            isLow: true
        },
        {
            name: "7 Circle Trajectory (hard)",
            description: "Take your 8 iron. How many shots does it take you to hit a ball through each circle in a row? Then take your 5 iron and do the same thing.",
            low: 0,
            high: 18,
            isLow: true
        },
        {
            name: "Side Danger 50-100",
            description: "You will need a target at 50, 60, 70, 80, 90 and 100 yds. Launch monitor is suggested but not required. You will hit one ball to a target at a time and alternate the \"dangerouns\" side and repeat it for a total of 24 shots. If you miss the target on the dangerous side you get -5pts. If you miss target on the safe side by less than 5% (just less than 2 fingers) you get 3pts, less than 10% (just more than 3 fingers) 1pt, more than 10% 0pts.",
            low: 0,
            high: 100,
            isLow: true
        },
        {
            name: "Side Danger 100-150",
            description: "You will need a target at 100, 110, 120, 130, 140, 150 yds. Launch monitor is suggested but not required. You will hit one ball to a target at a time and alternate the \"dangerouns\" side and repeat it for a total of 24 shots. If you miss the target on the dangerous side you get -5pts. If you miss target on the safe side by less than 5% (just less than 2 fingers) you get 3pts, less than 10% (just more than 3 fingers) 1pt, more than 10% 0pts.",
            low: 0,
            high: 100,
            isLow: true
        },
        {
            name: "Side Danger 150-200",
            description: "You will need a target at 150, 160, 170, 180, 190 and 200 yds. Launch monitor is suggested but not required. You will hit one ball to a target at a time and alternate the \"dangerouns\" side and repeat it for a total of 24 shots. If you miss the target on the dangerous side you get -5pts. If you miss target on the safe side by less than 5% (just less than 2 fingers) you get 3pts, less than 10% (just more than 3 fingers) 1pt, more than 10% 0pts.",
            low: 0,
            high: 100,
            isLow: true
        },
        {
            name: "Side Danger 200+",
            description: "You will need a target at 200, 210, 220, 230, 240, 250 yds. Launch monitor is suggested but not required. You will hit one ball to a target at a time and alternate the \"dangerouns\" side and repeat it for a total of 24 shots. If you miss the target on the dangerous side you get -5pts. If you miss target on the safe side by less than 5% (just less than 2 fingers) you get 3pts, less than 10% (just more than 3 fingers) 1pt, more than 10% 0pts.",
            low: 0,
            high: 100,
            isLow: true
        },
        {
            name: "Knockout",
            description: "You will hit 10 zones with your wedges. From your 12 wedge shots you will hit all distances but full LW and 7:30 PW. To knock a distance out you need to hit the ball within 2 yards of your yardage. To win the game you need 20 shots or less.",
            low: 18,
            high: 21,
            isLow: true
        },
        {
            name: "30 Bank",
            description: "You start the game with $30. You will hit 10 shots with your wedges. From your 12 wedge shots you will hit all distances but full LW and 7:30 PW. For each yard you're off in distance you loose $1. If you hit your distance you get a $2 credit. The goal is to hit your 10 yardages and have money left at the end of the game. Continue the game to the end and write down how much money you had left.",
            low: -1,
            high: 8,
            isLow: false
        },
        {
            name: "10 Cone Birdie",
            description: "On the practice facility, set up 10 cones (or the marker of your choice) at 10-yard increments from 30 to 120 yards (27-109m). Play a distance wedge to each cone in succession. Count the number of shots that land within two steps of the cones. Win your way off the practice facility by hitting 7 shots to within 2 paces.",
            low: 6,
            high: 8,
            isLow: false
        },
        {
            name: "90-Yard 23",
            description: "When the course is a little empty, head to a hole and play one ball all the way in, starting at 10 yards from the pin. Repeat at 10-yard increments all the way up to 90. When you finish all nine holes, add up your strokes. A winning score is 23 or lower.",
            low: 22,
            high: 24,
            isLow: true
        },
        {
            name: "7",
            description: "From the same location in the bunker, play one ball to three different holes. Complete each hole by holing out with your putter. To win the game, you must complete all three in 7 strokes or less. Write down score for each try.",
            low: 6,
            high: 8,
            isLow: true
        },
    ]

    const teeGames = [
        {
            name: "Tee Shot Points",
            description: "You will hit 14 balls with your driver.  Pick a different target for each shot. Create 2 zones with the middle being your target: 25y wide=2p, 45y wide=1p. On shot 1 there are no penalties. On shot 2 if you miss the 45y zone to the right=-1p. On shot 3 if you miss the 45y zone to the left=-1p. On shot 4if you miss the 45y zone on either side=-1p and so on... Shot 13 no penalties. Shot 14 penalties on both sides. Write down your score.",
            low: 10,
            high: 20,
            isLow: false
        },
        {
            name: "Driver Impact Control",
            description: "You will need 10 balls and spray/face sticker/GC Quad to track impact location. Draw a cross on your driver face ccreating 4 zones: high toe, high heel, low toe, low heel. Hit each zone and record if you were succesfull. On 5th shot hit the middle. Repeat for a total number of 10 shots. Write down the number of successes.",
            low: 10,
            high: 20,
            isLow: false
        }
    ]

    const combineGames = [
        {
            name: "Putting Combine",
        },
        {
            name: "50-100y Combine",
        },
        {
            name: "75-125y Combine",
        },
        {
            name: "100-150y Combine",
        },
        {
            name: "150-200y Combine",
        },
        {
            name: "Green Reading",
        }

    ]

    const courseGames = [
        {
            group: "9 holes",
            drills: [
                {
                    name: "Points 9 holes",
                    description: "You get 1 point for FIR, 1 point for GIR, 1 point for 1-putt, 1 point for birdie (2 for eagle). Count how many points you got.",
                    low: 15,
                    high: 18,
                    isLow: false,//is low good,
                },
                {
                    name: "Par 9 holes",
                    description: "Play 9 holes and count how many pars you got. Birdie and better counts as par",
                    low: 7,
                    high: 9,
                    isLow: false,//is low good,
                },
                {
                    name: "Forward tees 9 holes",
                    description: "Play 9 holes from forward tees (for ladies maybe start from back of the fairway on some of the holes). GO LOW! Write down the score in relation to par.",
                    low: -4,
                    high: -2,
                    isLow: true,//is low good,
                },
                {
                    name: "Best Ball 9 holes",
                    description: "Play 9 holes and from each sport hit 2 balls. Alway pick the better shot. Write down the score in relation to par",
                    low: -4,
                    high: -2,
                    isLow: true,//is low good,
                },
                {
                    name: "Worst Ball 9 holes",
                    description: "Play 9 holes and from each sport hit 2 balls. Alway pick the worse shot. Write down the score in relation to par",
                    low: 1,
                    high: 4,
                    isLow: true,//is low good,
                },
                {
                    name: "9 hole Points Offence/Defence Game",
                    description: "Play 9 holes and score as many points as you can. Points are as such: GIR inside 40'=1pt, GIR inside 20'=2pts, GIR inside 8'=3pts. Double the points if you convert it to a birdie. Bogey = -3pts. 2 Bogeys = loose all points up to that point. Write down the points earned",
                    low: 20,
                    high: 23,
                    isLow: false,//is low good,
                },
                {
                    name: "Extra club 9 holes",
                    description: "Play 9 holes of regular stroke play, but on every approach you must take one club more than usually. So make you decision on what you would normally hit and then take a club more (it might be 1.5 clubs more if you're in between clubs). Write down the score in relation to par.",
                    low: 0,
                    high: 2,
                    isLow: true,//is low good,
                },
            ]
        }, {
            group: "18 holes",
            drills: [
                {
                    name: "Par 18 holes",
                    description: "Play 18 holes and count how many pars you got. Birdie and better counts as par",
                    low: 16,
                    high: 18,
                    isLow: false,//is low good,
                },
                {
                    name: "Attack",
                    description: "Play 18 holes and count only the best 9 holes in relation to par. Write down your score in relation to par",
                    low: -5,
                    high: -2,
                    isLow: true,//is low good,
                },
                {
                    name: "Points 18 holes",
                    description: "You get 1 point for FIR, 1 point for GIR, 1 point for 1-putt, 1 point for birdie (2 for eagle). Count how many points you got.",
                    low: 30,
                    high: 33,
                    isLow: false,//is low good,
                },
                {
                    name: "Forward tees 18 holes",
                    description: "Play 18 holes from forward tees (for ladies maybe start from back of the fairway on some of the holes). GO LOW! Write down the score in relation to par.",
                    low: -6,
                    high: -3,
                    isLow: true,//is low good,
                },
                {
                    name: "Par 3 course",
                    description: "Play 18 holes on a par 3 couse. Write down the score in relaiton to par.",
                    low: -2,
                    high: 2,
                    isLow: true,//is low good,
                },
                {
                    name: "Extra club 18 holes",
                    description: "Play 9 holes of regular stroke play, but on every approach you must take one club more than usually. So make you decision on what you would normally hit and then take a club more (it might be 1.5 clubs more if you're in between clubs). Write down the score in relation to par.",
                    low: 0,
                    high: 3,
                    isLow: true,//is low good,
                },
            ]
        },

    ]

    return (
        <GamesContext.Provider value={{ puttingGames, argGames, appGames, teeGames, combineGames, courseGames }} >
            {children}
        </GamesContext.Provider>
    );
};

export const useGames = () => {
    return useContext(GamesContext);
};
